export const MARKETS_SV = {
    match_odds_ft: "Matchodds (fulltid)",
    match_odds_ht: "Matchodds (halvtid)",
    goals_ft: "Över/Under {{line}} mål (fulltid)",
    goals_ht: "Över/Under {{line}} mål (halvtid)",
    player_scores: "{{player}} gör mål (fulltid)",
    corners_ft: "Hörnor över/under {{line}} (fulltid)",
    cards_ft: "Kort över/under {{line}} (fulltid)",
    draw: "Oavgjort",
    over: "Över {{line}}",
    under: "Under {{line}}",
    yes: "Ja",
    no: "Nej",
}
